import React from 'react';
import vk from '../../images/social_media_icon_vk.png';
import insta from '../../images/social_media_icon_insta.png';
import youtube from '../../images/social_media_icon_youtube.png';

const TERMS_URL =
  'https://firebasestorage.googleapis.com/v0/b/ziel-studienkolleg.appspot.com/o/Documents%2F%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D1%81%D0%BA%D0%BE%D0%B5%20%D1%81%D0%BE%D0%B3%D0%BB%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%BF%D0%BB%D0%B0%D1%82%D1%84%D0%BE%D1%80%D0%BC%D1%8B.pdf?alt=media&token=18d295a5-1cb0-4bf2-8ec8-e3ac084acb75';
const PRIVACY_URL =
  'https://firebasestorage.googleapis.com/v0/b/ziel-studienkolleg.appspot.com/o/Documents%2F%D0%9F%D0%BE%D0%BB%D0%B8%D1%82%D0%B8%D0%BA%D0%B0%20%D0%BA%D0%BE%D0%BD%D1%84%D0%B8%D0%B4%D0%B5%D0%BD%D1%86%D0%B8%D0%B0%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8.pdf?alt=media&token=99bf3913-7012-4c2c-ac2c-3c65b916d3b5';

const socialLinks = [
  { href: 'https://vk.com/zielstudienkolleg', image: vk, label: 'VK' },
  { href: 'https://instagram.com/zielstudienkolleg', image: insta, label: 'Instagram' },
  {
    href: 'https://www.youtube.com/channel/UCbEhG_fiHO_94OlFi1FWaXQ',
    image: youtube,
    label: 'YouTube',
  },
];

const Footer = () => (
  <footer id="landing-footer" className="site-footer">
    <div className="site-footer__grid">
      <div className="site-footer__brand">
        <span className="site-footer__eyebrow">ZielStk</span>
        <h2>Подготовка к Studienkolleg в удобном формате.</h2>
        <div className="site-footer__socials" aria-label="Социальные сети">
          {socialLinks.map(({ href, image, label }) => (
            <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
              <img src={image} alt="" />
            </a>
          ))}
        </div>
      </div>

      <div className="site-footer__legal">
        <span className="site-footer__eyebrow">Реквизиты</span>
        <h3>Иван Хохряков</h3>
        <p>ИНН: 660706007482</p>
        <p>г. Калининград, ул. Красная 109</p>
        <p>
          <a href="mailto:zielstundienkolleg@gmail.com">
            zielstundienkolleg@gmail.com
          </a>
        </p>
        <div className="site-footer__documents">
          <a href={TERMS_URL} target="_blank" rel="noopener noreferrer">
            Договор оферта
          </a>
          <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">
            Безопасность данных
          </a>
        </div>
      </div>
    </div>

    <div className="site-footer__bottom">
      <span>© Ivan Khokhryakov und Nadezhda Provotorova</span>
      <span>Материалы для подготовки к поступлению</span>
    </div>
  </footer>
);

export default Footer;
